import { InvestmentTransactionType } from "hooks/investments/GetInvestmentTransactionsHook";
import { InvestmentType } from "types/InvestmentTypes";
import {
  TYPE_LABELS,
  formatDate,
  FileCell,
  FileCellReadOnly,
  DotsMenu,
  MobileActions,
} from "./tableUtils";
import { isDesktop } from "utils";

interface CryptoTableProps {
  transactions: InvestmentTransactionType[];
  item: InvestmentType | null;
  isOwn?: boolean;
  isAdmin?: boolean;
  onEditTx?: (tx: InvestmentTransactionType) => void;
}

const CryptoTable = ({
  transactions,
  item,
  isOwn = false,
  isAdmin = false,
  onEditTx,
}: CryptoTableProps) => {
  const fmtNum = (val: number) => {
    return val
      .toLocaleString("en-US", {
        minimumFractionDigits: Number.isInteger(val) ? 0 : 2,
        maximumFractionDigits: 8,
      })
      .replace(/,/g, "\u00A0");
  };

  if (!isDesktop()) {
    return (
      <div className="itm-mobile-list">
        {transactions.map((tx) => {
          const quantity = tx.quantity ?? null;
          const rawRate = tx.totalValue != null ? Number(tx.totalValue) : null;
          const rateIsZero = rawRate === 0;
          const rate = rateIsZero ? null : rawRate;
          const cost =
            quantity != null && rate != null ? quantity * rate : null;
          const currencyCode = tx.currency?.currency ?? "";
          return (
            <div key={tx.uuid} className="itm-mobile-card">
              <table className="side-modal__table">
                <tbody>
                  <tr>
                    <td className="side-modal__table-label">Klient:</td>
                    <td className="side-modal__table-cell">
                      {isAdmin
                        ? tx.type === "sell"
                          ? tx.name ?? TYPE_LABELS[tx.type]
                          : "Reliance"
                        : TYPE_LABELS[tx.type] ?? tx.type}
                    </td>
                  </tr>
                  <tr>
                    <td className="side-modal__table-label">Data:</td>
                    <td className="side-modal__table-cell">
                      {formatDate(tx.completedAt ?? tx.createdAt)}
                    </td>
                  </tr>
                  <tr>
                    <td className="side-modal__table-label">Ilość sztuk:</td>
                    <td className="side-modal__table-cell">
                      {tx.type === "buy" ? "+" : "-"}
                      {quantity != null ? fmtNum(quantity) : "Brak"}
                    </td>
                  </tr>
                  <tr>
                    <td className="side-modal__table-label">Kurs:</td>
                    <td className="side-modal__table-cell">
                      {rate != null ? fmtNum(rate) : "Brak"}
                    </td>
                  </tr>
                  <tr>
                    <td className="side-modal__table-label">Koszt nabycia:</td>
                    <td className="side-modal__table-cell">
                      {cost != null
                        ? `${fmtNum(cost)}${
                            currencyCode ? ` ${currencyCode}` : ""
                          }`
                        : "Brak"}
                    </td>
                  </tr>
                </tbody>
              </table>
              <MobileActions
                tx={tx}
                onEdit={
                  onEditTx && (isAdmin || isOwn || tx.type === "sell")
                    ? () => onEditTx(tx)
                    : undefined
                }
              />
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <table className="itm-table">
      <thead>
        <tr>
          <th style={{ paddingLeft: 12 }}>Klient</th>
          <th>Data</th>
          <th>Ilość sztuk</th>
          <th>Umowa</th>
          <th>Kurs</th>
          <th>Koszt nabycia</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((tx) => {
          const quantity = tx.quantity ?? null;
          const rawRate = tx.totalValue != null ? Number(tx.totalValue) : null;
          const rateIsZero = rawRate === 0;
          const rate = rateIsZero ? null : rawRate;
          const cost =
            quantity != null && rate != null ? quantity * rate : null;
          const currencyCode = tx.currency?.currency ?? "";

          return (
            <tr key={tx.uuid}>
              <td style={{ paddingLeft: 12 }}>
                {isAdmin
                  ? tx.type === "sell"
                    ? tx.name ?? TYPE_LABELS[tx.type]
                    : "Reliance"
                  : TYPE_LABELS[tx.type] ?? tx.type}
              </td>
              <td>{formatDate(tx.completedAt ?? tx.createdAt)}</td>
              <td>
                {tx.type === "buy" ? "+" : "-"}
                {quantity != null ? fmtNum(quantity) : "Brak"}
              </td>
              <td>
                {onEditTx ? <FileCell tx={tx} /> : <FileCellReadOnly tx={tx} />}
              </td>
              <td>{rate != null ? fmtNum(rate) : "Brak"}</td>
              <td>
                {cost != null
                  ? `${fmtNum(cost)}${currencyCode ? ` ${currencyCode}` : ""}`
                  : "Brak"}
              </td>
              <td>
                <DotsMenu
                  tx={tx}
                  onEdit={
                    onEditTx && (isAdmin || isOwn || tx.type === "sell")
                      ? () => onEditTx(tx)
                      : undefined
                  }
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default CryptoTable;
